import { render, staticRenderFns } from "./WyCard.vue?vue&type=template&id=15000e14&scoped=true&"
import script from "./WyCard.vue?vue&type=script&lang=js&"
export * from "./WyCard.vue?vue&type=script&lang=js&"
import style0 from "./WyCard.vue?vue&type=style&index=0&id=15000e14&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15000e14",
  null
  
)

export default component.exports